<div class="c-portlet u-bg-main u-shadow-mini {{ sectionclass }}" (window:resize)="onResize($event)">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet__content pos-relative map-height">
		<div>
			<!-- [ngClass]="{'map-height-abstop' : (range === 'WITHIN')}" -->
			<div class="map-wrapper">
				<!-- 'map-height-abstop' : (range === 'WITHIN') -->
				<div id="map" class="map-height" style="width: 100%" [ngClass]="{ 'map-with-no-data': noData }"></div>
				<div id="geoInfo" *ngIf="!noData && !showGeofenceCenterDetailsFlag" class="grid-6">
					<div class="polygon-layer-info zip-div" *ngIf="polygonLayerDetails.zip">
						Postal Code:<span>&nbsp;{{ polygonLayerDetails.zip }}</span>
					</div>
					<div class="polygon-layer-info zip-div" *ngFor="let detail of liftDetails" [ngClass]="detail.attribute">
						<p *ngIf="detail.value">
							{{ detail.attribute }}<span>&nbsp;{{ detail.addDollar ? '$' + detail.value : detail.value }}</span>
						</p>
					</div>
					<div class="polygon-layer-info population-div" *ngIf="polygonLayerDetails.population">
						Population:<span>&nbsp;{{ polygonLayerDetails.population }}</span>
					</div>
				</div>
				<div id="geofence-disclaimer" class="geofence-disclaimer">
					<div class="geofence-disclaimer-section">
						<img class="geofence-disclaimer-img" src="../../../../../../assets/images/info-circle.png" />
						<span class="geofence-disclaimer-text"
							>Geofence/geo recency points may not display due to category-specific privacy restrictions in a selected
							campaign.</span
						>
					</div>
				</div>
			</div>

			<div class="map-details-container">
				<div class="details-map-container">
					<div id="minimap" style="height: 200px"></div>
				</div>
				<div class="map-details-wrapper">
					<span>Geofence Location</span>
					<div class="map-region-dmographic-title">
						{{ geofenceCenterDetails ? geofenceCenterDetails.address : '' }}
					</div>
					<div class="accordion-table" style="width: 100%">
						<div *ngFor="let detail of geofenceCenterDetailsForMap">
							<span class="left-text">{{ detail.attribute }}</span>
							<span class="right-text">{{ detail.value }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="zoom-options">
				<div class="zoom-icon" (click)="zoomIn()">
					<i class="fa fa-plus" aria-hidden="true"></i>
				</div>
				<div class="zoom-icon" style="border-top: 0px" (click)="zoomOut()">
					<i class="fa fa-minus" aria-hidden="true"></i>
				</div>
			</div>
			<div class="liftdata" *ngIf="showLiftData && showPolygonLayerDetailsFlag && !showGeofenceCenterDetailsFlag">
				<div class="details" *ngIf="polygonLayerDetails?.avgLift">
					Digital Lift: {{ polygonLayerDetails?.avgLift }}x
				</div>
				<div>
					<span class="ratingPer title-font liftDat-ratingPer" *ngIf="polygonLayerDetails?.averageBaseline">
						{{ polygonLayerDetails?.averageBaseline }}% Baseline Rate</span
					>
				</div>
				<div class="ratingtext">
					<span class="ratingPer title-font liftDat-ratingPer" *ngIf="polygonLayerDetails?.averageExposeRate"
						>{{ polygonLayerDetails?.averageExposeRate }}% Exposed Rate</span
					>
				</div>
			</div>
			<div id="product-list">
				<div
					class="legend-area"
					*ngIf="mapObj?.legend && (selectedState == 'all' || selectedState == 'display' || selectedState == 'preroll')"
				>
					<ul class="legend">
						<li
							class="legend_item primary-color-border {{ legendItem.productName }}"
							[ngClass]="{ 'primary-color ': legendItem.isSelected, 'disable-button': legendItem.isDisabled }"
							(click)="selectedProductDetails(legendItem)"
							*ngFor="let legendItem of mapObj?.legend"
						>
							<span>{{ legendItem.productName }}</span>
							<i
								*ngIf="legendItem.isSelected"
								class="fa fa-caret-left"
								[ngStyle]="{ 'font-size': '18px', color: colorPalette.primaryColor }"
							></i>
							<i *ngIf="!legendItem.isSelected" class="space"></i>
						</li>
					</ul>
				</div>
			</div>
			<div class="geocenter-info" *ngIf="showGeofenceLegends && (selectedState == 'all' || selectedState == 'display')">
				<div class="geocenter">Legend</div>
				<div class="geocenter">
					<div
						class="geofence-dot"
						[ngClass]="
							geofencecirclemarkercolor &&
							geofencecirclemarkercolor !== 'undefined' &&
							geofencecirclemarkercolor !== 'null'
								? geofencecirclemarkercolor + '-color-bg'
								: 'secondary-color-bg'
						"
					></div>
					<div class="geo-values">Geofence</div>
				</div>
				<div class="geocenter">
					<div
						class="recency-dot"
						[ngClass]="
							georecencycirclemarkercolor &&
							georecencycirclemarkercolor !== 'undefined' &&
							georecencycirclemarkercolor !== 'null'
								? georecencycirclemarkercolor + '-color-bg'
								: 'tertiary-color-bg'
						"
					></div>
					<div class="geo-values">Geo Recency</div>
				</div>
			</div>

			<div class="no-data-container" *ngIf="noData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
